export default __webpack_public_path__ + "static/media/sweet1.bdebc148.jpg";